export enum RoleEnum {
    User = 0,
    Admin = 1,
    SuperAdmin = 2
}